import {Injectable} from '@angular/core';
import {db} from '../db.service';
import {TtWorkingTimeType} from '../../interfaces/time-tracking/tt-working-time-type';
import {StaticTable} from '../static.table';

@Injectable({
  providedIn: 'root'
})
export class TtWorkingTimeTypesTable extends StaticTable<TtWorkingTimeType> {
  constructor() {
    super(db.ttWorkingTimeTypes);
  }
}
